import { TSortColumn, TSortDirection } from '../../classes/grid-page-info';

export type IEra = {
  billingNpi: string;
  billingTaxId: string;
  claimCount: number;
  dateReceived: string;
  effectiveDate: string;
  groupId: string;
  inputFilename: string;
  outputFilename: string;
  payerId: string;
  payerName: string;
  payerTaxId: string;
  paymentAmount: number;
  status: EraStatus;
  submitterId: string;
  submitterName: string;
  traceNumber: string;
  transmissionDate: string;
};

export type IGQLErasParams = {
  after?: string;
  direction: TSortDirection;
  filter: EraFilters;
  orderby: TSortColumn;
};

export type EraFilters = {
  billingNpi?: string;
  billingTaxId?: string;
  claimCount?: number;
  dateFrom: string;
  dateReceived?: string;
  dateTo: string;
  effectiveDate?: string;
  eraDate: string;
  groupId?: string;
  inputFilename?: string;
  outputFilename?: string;
  payerId?: string;
  payerName?: string;
  payerTaxId?: string;
  paymentAmount?: string;
  status?: EraStatus;
  submitterId?: string;
  traceNumber?: string;
  transmissionDate?: string;
};

export type EraStatusUpdate = {
  [param: string]:
    | boolean
    | number
    | readonly (boolean | number | string)[]
    | string
    | undefined;
  Filenames: string | string[];
  ProcessedTime?: string;
  Status: EraStatus;
  SubType?: string;
  X_GROUP_ID: string;
};

export const EraStatuses = [
  'COMPLETE',
  'DUPLICATE',
  'HELD',
  'IN_PROCESS',
  'MISSING',
  'RETRY',
  'TEST',
  'WAITING',
] as const;

export type EraStatus = (typeof EraStatuses)[number];

export const SubTypes = [277, 271, 276] as const;

export type SubType = (typeof SubTypes)[number];

export type IEraDTO = {
  isExpanded: boolean;
} & IEra;
